/**
 * Labstep
 *
 * @module components/EntityView/Action/Menu
 * @desc List of actions for EntityView
 */

import { EntityActionTag } from 'labstep-web/components/Entity/Action/Tag';
import EntityViewActionDelete from 'labstep-web/components/EntityView/Action/Delete';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { EntityViewActionMenuProps } from './types';

export enum Action {
  delete = 'delete',
  tag = 'tag',
  add_to_folder = 'add_to_folder',
  remove_from_folder = 'remove_from_folder',
}

export const EntityViewActionMenu: React.FC<
  EntityViewActionMenuProps
> = ({ entityView, type, actions = [] }) => (
  <ActionMenu type={type}>
    {actions.includes(Action.tag) && (
      <EntityActionTag parentEntity={entityView} />
    )}
    {actions.includes(Action.delete) && (
      <EntityViewActionDelete entityView={entityView} />
    )}
  </ActionMenu>
);

EntityViewActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
